// import React from "react";
// import { NavLink, Outlet } from "react-router-dom";

// const SideNavLayout = () => {
//   const navItems = [
//     { name: "Orders", path: "/orders" },
//     { name: "Saved Items", path: "/saved-items" },
//     { name: "Manage Account", path: "/manage-account" },
//     { name: "Become a Supplier", path: "/become-supplier" },
//     { name: "Support", path: "/support" },
//     // { name: "Change Location", path: "/change-location" },
//   ];

//   return (
//     <div className="flex h-full lg:container">
//       {/* Side Navigation (Hidden on smaller screens, visible on lg screens) */}
//       <nav className="hidden lg:block w-64 bg-white shadow-md p-4 h-[50vh]">
//         {/* <nav className="hidden lg:block w-64 bg-white shadow-md p-4 h-[50vh]"> */}
//         <ul>
//           {navItems.map((item) => (
//             <li key={item.name} className="mb-4">
//               <NavLink
//                 to={item.path}
//                 className={({ isActive }) =>
//                   `block py-2 px-4 rounded-md ${
//                     isActive ? "bg-green-500 text-white" : "text-gray-600"
//                   }`
//                 }
//               >
//                 {item.name}
//               </NavLink>
//             </li>
//           ))}
//         </ul>
//       </nav>

//       {/* Content Area */}
//       <main className="flex-1 p-2 md:p-4 overflow-y-auto">
//         <Outlet /> {/* Render the specific content here */}
//       </main>
//     </div>
//   );
// };

// export default SideNavLayout;

import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const SideNavLayout = () => {
  const navItems = [
    { name: "Orders", path: "/orders", icon: "shopping_bag" },
    { name: "Saved Items", path: "/saved-items", icon: "favorite" },
    {
      name: "Manage Account",
      path: "/manage-account",
      icon: "manage_accounts",
    },
    {
      name: "Become a Supplier",
      path: "/become-supplier",
      icon: "local_shipping",
    },
    { name: "Support", path: "/support", icon: "headset_mic" },
  ];

  return (
    <div className="flex h-full lg:container">
      {/* Side Navigation */}
      <nav className="hidden lg:block w-64 bg-white shadow-md p-4 rounded-xl h-fit mt-4">
        <ul className="space-y-2">
          {navItems.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium cursor-pointer ${
                    isActive
                      ? "bg-agBg text-agBlack"
                      : "text-gray-600 hover:bg-gray-100"
                  }`
                }
              >
                <span className="material-symbols-rounded text-[20px]">
                  {item.icon}
                </span>
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Content Area */}
      <main className="flex-1 p-4 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default SideNavLayout;
